export default function AircraftCard({aircraft, tags}) {
    
    const version = aircraft._version ? parseInt(aircraft._version) : 1
    const scheme = version === 3 && isObject(aircraft.class.image) ? aircraft.class.image.url : aircraft.class.image
    
    const getValue = (item) => {
        return version === 3 ? (item.label || item.value) : item;
    }

    const getUnits = (item) => {
        return version === 3 ? item.units : '';
    }
    
    const tagsFiltered = (tags || []).filter(e => e.value !== 'unviewed')

    return <div className="offer-modal__desc">
        <div className="offer-modal__top">
            <div>
                <h3 className="offer-modal__title">{aircraft.title}</h3>
                <div className="offer-modal__info">
                    {!!aircraft.year && <span>{aircraft.year}</span>}
                    <span>{aircraft.class.title}</span>
                </div>
                {tagsFiltered.length > 0 && <div className="offer-modal__tags">
                    {tagsFiltered.map(tag => <span key={`tags-${tag.label}`} >{tag.label}</span>)}
                </div>}
            </div>
            <div className="offer-modal__sheme">
                <img src={scheme} alt=""/>
            </div>
        </div>
        <div className="offer-modal__center">
            <ul className="offer-modal__list">
                <AircraftParameter title={tMsg('Питание')} value={getValue(aircraft.facilities.food)} />
                <AircraftParameter title={tMsg('Стюардесса')} value={getValue(aircraft.facilities.stewardess)} />
                <AircraftParameter title={tMsg('Интернет')} value={getValue(aircraft.facilities.internet)} />
                <AircraftParameter title={tMsg('WC')} value={getValue(aircraft.facilities.toilet)} />
                <AircraftParameter title={tMsg('Курение')} value={getValue(aircraft.facilities.smoke)} />
                <AircraftParameter title={tMsg('VIP-терминал')} value={getValue(aircraft.facilities.vip)} />
            </ul>
            <ul className="offer-modal__list">
                <AircraftParameter title={tMsg('Места')} value={getValue(aircraft.params.seats)} />
                <AircraftParameter title={tMsg('Высота салона')} value={getValue(aircraft.params.height)} unit={getUnits(aircraft.params.height)} />
                <AircraftParameter title={tMsg('Ширина салона')} value={getValue(aircraft.params.width)} unit={getUnits(aircraft.params.width)} />
                <AircraftParameter title={tMsg('Длина салона')} value={getValue(aircraft.params.length)} unit={getUnits(aircraft.params.length)} />
                <AircraftParameter title={tMsg('Объем багажника')} value={getValue(aircraft.params.trunk)} unit={getUnits(aircraft.params.trunk)} />
                {!!aircraft.update && <AircraftParameter title={tMsg('Обновление салона')} value={getValue(aircraft.params.update_year)} unit={getUnits(aircraft.params.update_year)} />}
            </ul>
        </div>
    </div>
}

function AircraftParameter({ title, value, unit = '' }) {
    if (!value)
        return null
    
    const formattedValue = isNaN(parseFloat(String(value))) ? value : String(value).replace('.', ',')
    return <li>
        <span>{title}</span>
        <span dangerouslySetInnerHTML={{__html: `${formattedValue} ${unit}`}} />
    </li>
    
}

const isObject = (val) => {
    return typeof val === 'object' && val !== null && !Array.isArray(val);
}
